import {Table, Form, Space, Radio, Badge, Flex, InputNumber, DatePicker, Input } from 'antd'
import React, { useEffect, useState } from 'react'
import InvoiceCheck from './InvoiceCheck';
import Copy from '../../cpn/Copy';
import ReportCheck from '../../document/report/ReportCheck';
import classes from './invoice.module.css';
import StateTag from '../../cpn/StateTag';
import Icon from '../../cpn/Icon';
import ClientSelect from '../../system/client/ClientSelect';
import dayjs from 'dayjs';
import UserSelect from '../../system/user/UserSelect';
function InvoiceListAll(props) {
    const [form] = Form.useForm();
    const [list,setList] = useState([]);   
    const [query, setQuery] = useState({
      "kpsq_state": '',     
  });
    useEffect(() => {
        let arr = props.list.slice();   
        if (props.list) {
            if(query.kpsq_state){
              arr = arr.filter((item) => item.kpsq_state === query.kpsq_state);
            }
            if(query.kpsq_amount){
              arr = arr.filter((item) => Number(item.kpsq_amount) === Number(query.kpsq_amount));
            }
            if(query.kpsq_kh_id){
              arr = arr.filter((item) => Number(item.kpsq_kh_id) === Number(query.kpsq_kh_id));
            }
            if(query.kpsq_ctime){
              arr = arr.filter((item) => dayjs(item.kpsq_ctime).format('YYYY-MM-DD') === query.kpsq_ctime);
            }
            if(query.kpsq_uid){
              arr = arr.filter((item) => item.kpsq_uid === query.kpsq_uid);
            }
            if(query.kpsq_id){
              arr = arr.filter((item) => item.kpsq_id === query.kpsq_id);
            }
            arr = arr.map((item) => ({
                ...item,
                key: item.key || item.kpsq_id
            }));
            arr.sort((a, b) => new Date(b.kpsq_ctime) - new Date(a.kpsq_ctime));
            setList(arr);
        }   
    }, [props.list, props.yh_id, query])
    
    const columns = [    
        {
            title: '开票项目',
            dataIndex: 'kpsq_kh_name',
            width: '12%',
            key: 'kpsq_kh_name',         
            render: (text, record) =><InvoiceCheck
                                        type='button'
                                        kpsq_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        kpsq_bzd_id={record.kpsq_bzd_id}
                                        kpsq_price={record.kpsq_price}
                                        kpsq_content={record.kpsq_content}
                                        kpsq_date={record.kpsq_date}
                                        kpsq_date_end={record.kpsq_date_end}
                                        kpsq_bzd_name={record.kpsq_bzd_name}
                                        kpsq_bzd_danhao={record.kpsq_bzd_danhao}
                                        kpsq_type_id={record.kpsq_type_id}
                                        kpsq_type_name={record.kpsq_type_name}
                                        kpsq_kh_id={record.kpsq_kh_id}
                                        kpsq_kh_name={record.kpsq_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        kpsq_num={record.kpsq_num}
                                        kpsq_amount={record.kpsq_amount}
                                        kpsq_state={record.kpsq_state}
                                        kpsq_bm_id={record.kpsq_bm_id}
                                        kpsq_bm_name={record.kpsq_bm_name}
                                        kpsq_khyhzh_id={record.kpsq_khyhzh_id}
                                        kpsq_khyhzh_name={record.kpsq_khyhzh_name}
                                        kpsq_image_name={record.kpsq_image_name}
                                        kpsq_image_file={record.kpsq_image_file}
                                        kpsq_ctime={record.kpsq_ctime}
                                        kpsq_uid={record.kpsq_uid}
                                    />
        },
        {
            title: '开票金额',
            dataIndex: 'kpsq_amount',
            width: '10%',
            key: 'kpsq_amount',   
            render: (text, record) => <span style={{ color: '#FF6600' }}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '开票项目',
            dataIndex: 'kpsq_name',
            key:'kpsq_name',
            render:(text, record) => <Copy title={record.kpsq_name}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"kpsq_bzd_name",
            key:'kpsq_bzd_name',
            render:(text,record) => <ReportCheck dsbzd_id={record.kpsq_bzd_id} dsbzd_name={record.kpsq_bzd_name} qy_id={props.qy_id} yh_id={props.yh_id} yh_name={props.yh_name} />
        },      
        {
            title: '状态',
            dataIndex: 'kpsq_state',
            width: '5%',
            key: 'kpsq_state',            
            render:(text) => <StateTag state={text} />
        },       
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },       
    ]
    return (
        <>                            
            <Flex style={{ marginBottom: "10px" }} align='center' justify='space-between'>
                <Form
                    layout='inline'
                    name='form_invoice_list_all'
                    form={form}
                    initialValues={{                        
                        kpsq_state: query.kpsq_state ? query.kpsq_state : '',                        
                    }}
                    onFinish={(values) => {
                        console.log(values);
                        // Serialize dayjs objects to strings before storing
                        const serializedValues = {
                            ...values,
                            kpsq_state: values.kpsq_state ? values.kpsq_state : '',
                            kpsq_kh_id: values.kpsq_kh_id ? values.kpsq_kh_id : '',
                            kpsq_content: values.kpsq_content ? values.kpsq_content : '',
                        };
                        
                        localStorage.setItem('jtg-caiwu_invoiceList_kpsq_state', JSON.stringify(serializedValues.kpsq_state));
                        localStorage.setItem('jtg-caiwu_invoiceList_kpsq_kh_id', JSON.stringify(serializedValues.kpsq_kh_id));
                        localStorage.setItem('jtg-caiwu_invoiceList_kpsq_content', JSON.stringify(serializedValues.kpsq_content));
                        setQuery(prev => ({ 
                            ...prev, 
                            kpsq_state: serializedValues.kpsq_state, 
                        }));
                    }}
                >
                    <Form.Item 
                        name='kpsq_state' 
                        label={props.label} 
                        required={props.required} 
                        style={props.style} 
                        wrapperCol={props.wrapperCol}
                        noStyle

                    >
                        <Radio.Group 
                            onChange={(e) => {
                                setQuery(prev => ({ 
                                    ...prev, 
                                    kpsq_state: e.target.value,                                     
                                }));
                                localStorage.setItem('jtg-caiwu_invoiceList_kpsq_state', JSON.stringify(e.target.value));
                            }}
                            buttonStyle='solid'
                            optionType="button" 
                        >
                            <Radio value='' >全部</Radio>
                            <Radio value='2' >待审批</Radio>
                            <Radio value='3' >审批中</Radio>                
                            <Badge>
                                <Radio value='4' >已驳回</Radio>
                            </Badge>
                            <Radio value='5' >已结束（未读）</Radio>
                            <Radio value='6' >已结束（已读）</Radio>
                        </Radio.Group>        
                    </Form.Item>    
                    <Form.Item name='kpsq_amount' wrapperCol={{ offset: 2 }}>
                        <InputNumber
                            onChange={(value) => {
                                setQuery(prev => ({ ...prev, kpsq_amount: value }));
                            }}
                            value={query.kpsq_amount ? query.kpsq_amount : undefined}
                            placeholder='开票申请金额'
                            name='kpsq_amount'
                            style={{ width: '120px' }}
                        />
                    </Form.Item> 
                    <ClientSelect                       
                        formStyle={{ marginBottom: "0" }}
                        onClear={() => { setQuery(prev => ({ ...prev, kpsq_kh_id: '' })) }}
                        placeholder='开票申请客户'
                        qy_id={props.qy_id}
                        style={{ width: "150px" }}
                        name='kpsq_kh_id'
                        onChange={(khId) => { setQuery(prev => ({ ...prev, kpsq_kh_id: khId || '' })) }}
                        yh_id={props.yh_id}
                        list={props.commonList?.kf_data || props.commonList?.kh_data || []}
                        wrapperCol={{ span: 18 }}
                    />  
                    <Form.Item name='kpsq_ctime'>
                        <DatePicker 
                            onChange={(value) => {
                                setQuery(prev => ({ ...prev, kpsq_ctime: dayjs(value).format('YYYY-MM-DD') }));
                            }}
                            value={query.kpsq_ctime ? dayjs(query.kpsq_ctime) : null}
                            allowClear={true}
                            placeholder='开票申请日期'
                            name='kpsq_ctime'
                        />
                    </Form.Item>          
                    <UserSelect
                        formStyle={{ marginBottom: "0" }}
                        onClear={() => { setQuery(prev => ({ ...prev, kpsq_uid: '' })) }}
                        placeholder='操作员'
                        qy_id={props.qy_id}
                        style={{ width: "150px" }}
                        name='kpsq_uid'
                        onChange={(e) => {setQuery(prev => ({ ...prev, kpsq_uid: e.yh_id || '' }))}}
                    />
                    <Form.Item name='kpsq_id' >
                        <Input placeholder='开票申请编号' onChange={(e) => {setQuery(prev => ({ ...prev, kpsq_id: e.target.value || '' }))}} style={{ width: "120px" }} />
                    </Form.Item>
                    <Form.Item style={{marginLeft: 10}}>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon type='reset'
                                onClick={() => {
                                    form.resetFields()
                                    localStorage.setItem('jtg-caiwu_invoiceList_kpsq_state', JSON.stringify(''))
                                    setQuery({
                                        "kpsq_state": '',
                                        kpsq_kh_id: '',
                                        kpsq_amount: undefined,
                                        kpsq_uid: '',
                                        kpsq_ctime: '',
                                        kpsq_id: '',
                                    })
                                    form.setFieldsValue({
                                        kpsq_name: null,
                                        kpsq_kh_id: null,
                                        kpsq_amount: null,
                                        kpsq_uid: null,
                                        kpsq_ctime: null,
                                        kpsq_id: '',
                                    });
                                }}
                            />
                        </Space>
                    </Form.Item>
                </Form>  
            </Flex>
            <Table 
                className={classes.orangeHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.kpsq_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell key="summary-0" index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-1" index={1} colSpan={1}>
                                <span style={{color:'#FF6600'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell key="summary-2" index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无开票申请数据' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default InvoiceListAll